<template>
  <li class="app-dropdown-button-item" :class="{ disabled }">
    <a href="#" @click.prevent="onClick" :style="textColor ? 'color: ' + textColor : ''">
      <slot />
    </a>
  </li>
</template>

<script lang="ts">
import { Prop, Component } from "vue-property-decorator";
import { BaseComponent } from "../base-component/base-component";

@Component({
  name: "app-dropdown-button-item",
})
export default class AppDropdownButtonItem extends BaseComponent {
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ required: false }) textColor!: string;

  onClick() {
    if (this.disabled) {
      return;
    }

    this.$emit("click");
  }
}
</script>

<style lang="scss">
@import "@/scss/_colors.scss";

.app-dropdown-button-item {
  display: block;

  & > a {
    display: block;
    padding: 0.25rem 1.5rem;
    white-space: nowrap;
    color: var(--default-text-color);
    text-decoration: none;
    background-color: var(--default-bg-color);
    
    &:hover {
      background-color: var(--muted-bg-color);
    }
  }
  &.disabled > a {
    cursor: not-allowed;
    color: var(--muted-text-color);

    &:hover {
      background-color: var(--default-bg-color);
    }
  }
}
</style>
